import { fileApi } from 'yxt-biz-pc/packages/api';

// 获取水印配置信息
export const getWatermarkSettings = () => {
  return fileApi.get(`newWatermark/config?orgId=${localStorage.orgId}`, { fullResponse: true });
};
